module.exports = __webpack_public_path__ + "static/media/ic_3.c9b4fa8f.svg";